import { Activity, TrendingDown, TrendingUp } from "lucide-react";

export function getTrend(progressUpToToday: number) {
    if (progressUpToToday >= 100) {
        return {
            label: "En avance",
            icon: <TrendingUp className="size-3.5" />,
            badgeClass: "bg-emerald-50 text-emerald-700 border-emerald-200"
        };
    }
    if (progressUpToToday >= 80) {
        return {
            label: "Sur la trajectoire",
            icon: <Activity className="size-3.5" />,
            badgeClass: "bg-amber-50 text-amber-700 border-amber-200"
        };
    }
    return {
        label: "En retard",
        icon: <TrendingDown className="size-3.5" />,
        badgeClass: "bg-rose-50 text-rose-700 border-rose-200"
    };
}

function formatAllowanceNumber(value: number): string {
    const rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toLocaleString("fr-FR", { maximumFractionDigits: 1 });
}

/**
 * Wording for a penalty whose objective is a negative allowance and whose gauge
 * zero is that objective. Above it, the unused allowance. Below it, how far
 * past the objective the result sits, on a 100-point scale.
 */
export function allowanceLabel(current: number, goal: number): string {
    const margin = Math.round((current - goal) * 10) / 10;
    if (margin > 0) return `Marge de ${formatAllowanceNumber(margin)}`;
    if (margin === 0) return "Objectif atteint";
    return `−${formatAllowanceNumber(-margin)} % en dessous de l'objectif`;
}

export function format_with_unit(value: number, unit: string, decimal: number = 0) {
    if (unit == "%") {
        return `${(value * 100).toFixed(decimal)} %`;
    } else {
        return `${value.toFixed(decimal)} ${unit}${unit.length > 1 && Math.abs(value) > 1 ? "s" : ""}`;
    }
}

const eurFormatter = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0
});

/** Raw values as stored for targets: minutes as number, % as 0–1, € as amount. */
export function formatTargetQuantity(value: number, unit: string): string {
    if (unit === "min") {
        const safe = Math.max(0, Math.round(value));
        if (safe < 60) return `${safe} min`;
        const h = Math.floor(safe / 60);
        const m = safe % 60;
        if (m === 0) return `${h} h`;
        return `${h} h ${m.toString().padStart(2, "0")}`;
    }
    if (unit === "%") {
        return `${(value * 100).toFixed(1)} %`;
    }
    if (unit === "€") {
        return eurFormatter.format(value);
    }
    return `${value.toLocaleString("fr-FR", { maximumFractionDigits: 2 })} ${unit}`.trim();
}
